import React from 'react';
import DataTable from '../../smart-kit/data-table/DataTable';
import { SimpleCard } from 'app/components';
import { apiPaths } from 'app/services/api';
import { provinces } from '../agents/AgentForm';

const Stores = () => {
  const columns = [
    { name: 'Store Name', key: 'name' },
    { name: 'City', key: 'city' },
    { name: 'Shop Id', key: 'shop_id' },
    { name: 'Phone Number', key: 'phone_number' },
    // { name: 'Type', key: 'type' },
    { name: 'Warranties Count', key: 'warranties_count' },
    { name: 'Active Warranties', key: 'paid_warranties', sort: true },
    { name: 'Agent', key: 'agent_name' },
    {
      name: 'Create Date',
      key: 'created_at',
      type: 'date',
      sort: true,
    },
  ];

  const filtersOn = [
    { name: 'Store Name', key: 'name' },
    { name: 'Shop Id', key: 'shop_id' },
    { name: 'Phone Number', key: 'phone_number' },
    {
      name: 'Province',
      key: 'city',
      type: 'select',
      items: [
        ...provinces.map((province) => ({ value: province.slug, label: province.name })),
        { value: 'سایر', label: 'سایر' },
      ],
    },
  ];

  return (
    <div className="m-sm-30">
      <div className="py-3" />
      <SimpleCard>
        <DataTable
          title="Stores"
          path="stores"
          apipath={apiPaths.STORES}
          columns={columns}
          filtersOn={filtersOn}
          showExport
          actions={[
            {
              key: 'create',
              auth: ['agent'],
            },
            {
              key: 'edit',
              auth: ['agent'],
            },
            {
              key: 'view',
              auth: ['finance'],
            },
          ]}
          hideActions={['delete']}
          extraActions={[
            {
              label: 'Assign Card',
              path: 'assign-card',
              auth: ['agent'],
            },
          ]}
        />
      </SimpleCard>
    </div>
  );
};

export default Stores;
